module.exports = __webpack_public_path__ + "img/shangya-logo.ba58cb8b.png";